import { jsx as _jsx } from "react/jsx-runtime";
import { createDependencyInjectableComponent } from "@faire/retailer-visitor-shared/app/_lib/dependencyInjectableComponent";
import { useMaybePrefetchSearchPage } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/useMaybePrefetchSearchPage";
import React, { lazy } from "react";
export var LazySearchPageWithClientSidePrefetch = function() {
    useMaybePrefetchSearchPage();
    var SearchPage = useSearchPage();
    return /*#__PURE__*/ _jsx(SearchPage, {});
};
export var LazySearchPageNoPrefetch = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "search-page" */ "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/SearchPage").then(function(m) {
        return {
            default: m.SearchPage
        };
    });
});
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
LazySearchPageNoPrefetch.preload = function() {
    return import(/* webpackChunkName: "search-page" */ "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/SearchPage").then(function(m) {
        return {
            default: m.SearchPage
        };
    });
};
var _createDependencyInjectableComponent = createDependencyInjectableComponent(LazySearchPageNoPrefetch), useSearchPage = _createDependencyInjectableComponent.useDependencyInjectableComponent, SearchPageProvider = _createDependencyInjectableComponent.DependencyInjectableComponentProvider;
export { SearchPageProvider };
